export default __webpack_public_path__ + "static/media/aulutn.5cb498e7.svg";